<template>
  <div>
    <the-headersider></the-headersider>

    <section>
      <base-card>

        <h4>
          Payments for:
          <span v-if="clientName">
            {{ clientName }} (ID: {{ client_id }})
          </span>
        </h4>

        <br />

        <table
          v-if="filteredPayments.length"
          class="table table-striped table-bordered centre"
        >
          <thead>
            <tr>
              <th>Client ID</th>
              <th>Client Name</th>
              <th>Date</th>
              <th>Amount</th>
              <th>Paid By</th>
              <th>Phone</th>
              <th>Reference</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="payment in filteredPayments"
              :key="payment.id"
            >
              <td>{{ payment.clientId }}</td>
              <td>{{ clientName }}</td>
              <td>{{ formatDate(payment.payment_date) }}</td>
              <td>{{ payment.amount }}</td>
              <td>{{ payment.paid_by }}</td>
              <td>{{ payment.phone }}</td>
              <td>{{ payment.payment_reference }}</td>
            </tr>
          </tbody>
        </table>

        <div v-else-if="loaded" class="no-data">
          No payments found for this client.
        </div>

      </base-card>
    </section>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      payments: [],
      clients: [],
      clientMap: {},
      loaded: false
    };
  },

  computed: {
    client_id() {
      return Number(this.$route.params.client);
    },

    filteredPayments() {
      return this.payments.filter(
        payment =>
          Number(payment.clientId) === this.client_id
      );
    },

    clientName() {
      return this.clientMap[this.client_id] || "";
    }
  },

  async created() {
    try {
      const [paymentsRes, clientsRes] = await Promise.all([
        axios.get("https://api.roberms.com/heritage/get/payments"),
        axios.get("https://api.roberms.com/heritage/get/clients")
      ]);

      this.payments = paymentsRes.data;
      this.clients = clientsRes.data;

      // Build lookup map
      this.clientMap = this.clients.reduce((map, client) => {
        map[client.id] = client.client_name;
        return map;
      }, {});

      this.loaded = true;

    } catch (error) {
      console.error("Error loading data:", error);
      this.loaded = true;
    }
  },

  methods: {
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    }
  }
};
</script>

<style scoped>
.no-data {
  text-align: center;
  padding: 20px;
  font-weight: bold;
  color: #888;
}
</style>